<script setup lang="ts">
import { computed, StyleValue } from 'vue';

const props = withDefaults(
  defineProps<{
    height?: number;
    isOpen: boolean;
    style?: StyleValue;
    zIndex?: number;
  }>(),
  { height: 170, style: undefined, zIndex: 999 }
);
const modalHeight = computed(() => `${props.height}px`);
</script>
<template>
  <Teleport to="body">
    <div v-if="isOpen" class="modal" :style="style">
      <slot />
    </div>
  </Teleport>
</template>
<style lang="scss" scoped>
.modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: v-bind(modalHeight);
  background: white;
  border-bottom: 1px solid var(--color-border-default);
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1);
  z-index: v-bind(zIndex);
  transform: translateY(-100%);
  animation: slideDown 0.3s ease-out forwards;

  @keyframes slideDown {
    from {
      transform: translateY(-100%);
    }
    to {
      transform: translateY(0);
    }
  }
}
</style>
